export default __webpack_public_path__ + "static/media/lodgify_step2.a1658233.jpg";